var PnKBoost = function() {
  const state = {
    parent: null,
    boostPFSConfig: undefined,
    collectionId: 0,
    data: {},
    timer: null,
    injected: [],
  };

  const chooseType = {
    BUTTON_CHOOSE: 'BUTTON_CHOOSE',
    BUTTON_CHOOSE_ALL: 'BUTTON_CHOOSE_ALL',
    BUTTON_CLEAR_ALL: 'BUTTON_CLEAR_ALL',
  };

  const keys = {
    TITLE_CONTAINER: '$filterOptionTitleElement',
    TITLE_SELECTOR: 'boost-pfs-filter-option-title-text',
    ITEMS_CONTAINER: '$filterItemsContainerElement',
    BUTTON_SELECTOR: 'choose-all',
    BUTTON_TEXT_SELECTOR: 'boost-pfs-filter-option-value',
    BUTTON_GROUP: '{{ filter_group }}',
    BUTTON_CHOOSE: 'filterChoose',
    BUTTON_CHOOSE_ALL: 'filterChooseAll',
    BUTTON_CLEAR_ALL: 'filterClearAll',
  };

  const relationType = {
    OR: 'or',
    DEFAULT: 'default',
  };

  return class PnKBoostClass {
    constructor({ parent }) {
      state.parent = parent;
    }

    init() {
      window.addEventListener('load', async () => {
        await getBoost();

        fixSearchPageLabels();

        getData();

        updateGroups();
      });
    }

    getFilteredProducts({ filters = [], limit = 24, page = 1, relation = relationType.DEFAULT }) {
      return getFilteredProducts({ filters, limit, page, relation });
    }
  };

  function fixSearchPageLabels() {
    const utils = window.BoostPFS?.Utils;
    const labels = window.BoostPFS?.Labels?.search || {};
    const selectorProducts = window.BoostPFS?.Selector?.products || '.main-search';

    if (!utils.isSearchPage()) return;

    Object.keys(labels).forEach((key) => {
      if (typeof labels[key] === 'string')
        labels[key] = labels[key].replace('{{ breakline }}', '<br/>');
    });

    window.boostPFS._callAllRender();

    setTimeout(() => {
      const contentEmpty = document.querySelector(`${selectorProducts} .result-empty-search`);
  
      if (contentEmpty)
        contentEmpty.classList.add('visible');
    });
  }

  function initFilterDescriptions() {
    const template = document.querySelector('#filters-description')?.content.cloneNode(true);

    document.querySelector('.boost-pfs-filter-options-wrapper').appendChild(template);
  }

  function injectFilters() {
    const injectGroupFilters = (group) => {
      const filters = group.children;

      filters.forEach((filter) => {
        inject(filter, 'onApplyFilter', handleApplyFilter);
      });
    };

    runForEachGroup(injectGroupFilters);
  }

  function injectClearAll() {
    const clearAll = getClearAll();

    inject(clearAll, 'onClearAll', handleClearAll);
  }

  function updateGroups(msDelay = 200) {
    const duration = 10000;
    const required = 1000;
    const interval = 200;
    const start = Date.now();

    const hasAllChooseButtons = () => {
      const buttonsCount = document.querySelectorAll(`.${keys.BUTTON_SELECTOR}`).length;
      const groupsCount = getGroups().size;
      return buttonsCount === groupsCount;
    };

    const timer = async () => {
      const passed = Date.now() - start;
      const isLoading = boostPFS.filter.filterLoadingIcon.$element[0].style.display !== 'none';
      const hasAllButtons = hasAllChooseButtons();

      if (!isLoading || !hasAllButtons) {
        addChooseAllButtons();
        addBadges();
        injectFilters();
        injectClearAll();
        showFilterDescription();

        if (passed > required) return;
      }

      if (passed > duration) return;

      setTimeout(() => {
        requestAnimationFrame(timer);
      }, interval);
    };

    setTimeout(() => {
      requestAnimationFrame(timer);
    }, msDelay);
  }

  function showFilterDescription() {
    const flat = (arr) => arr.reduce((acc, sarr) => ([...acc, ...sarr]), []);

    const selectedFilters = flat(runForEachGroup(getSelectedFilters));
    const descriptionElements = [...document.querySelectorAll('.filters-description li')];
    const controls = document.querySelector('.filters-description-controls');
    const hasSelectedFilters = descriptionElements.reduce((acc, { id }) => acc || selectedFilters.includes(id), false);
    
    if (!descriptionElements.length)
      initFilterDescriptions();

    if (!hasSelectedFilters) return;

    if (controls && controls.classList.contains('hidden')) {
      controls.classList.remove('hidden');
      controls.classList.add('is-visible-on-desktop');
    }

    descriptionElements.forEach((element) => {
      if (selectedFilters.includes(element.id)) {
        element.classList.add('block');
        element.classList.remove('hidden');
        element.classList.add('swiper-slide');
      }
    })
  }

  function getSelectedFilters(_group, groupId) {
    const _groupId = groupId || _group.filterOptionId;
    const group = getGroup(_groupId) || _group;
    const selectedFilters =
      [...group.filterItems.values()].filter(({ isSelected }) => isSelected).map(({ value }) => value.replace(/ /g, '_').replace(/::/g, '__'));

    return selectedFilters;
  }

  function addChooseAllButtons() {
    runForEachGroup(addChooseButtonTo);
  }

  function addBadges() {
    let total = 0;
    const badgeTotal = document.querySelector('.control-filtering-badge');

    const addBadge = (group) => {
      if (!group[keys.TITLE_CONTAINER]) return;

      const filters = [...group.filterItems.values()];
      const selectedCount = filters.filter(({ isSelected }) => isSelected).length;
      const title = group[keys.TITLE_CONTAINER][0].querySelector(`.${keys.TITLE_SELECTOR}`);
      const badge =
        title?.querySelector('.filters-popup-group-badge') || (() => {
          const node = document.createElement('span');
          if (!title) return null;

          node.classList.add('filters-popup-group-badge');
          title.prepend(node);

          return node;
        })();

      if (!badge) return;

      total += selectedCount;

      if (selectedCount) {
        badge.textContent = selectedCount;
        badge.classList.add('visible');
      } else {
        badge.textContent = '';
        badge.classList.remove('visible');
      }
    };

    runForEachGroup(addBadge);

    if (badgeTotal) {
      if (total) {
        badgeTotal.textContent = total;
        badgeTotal.classList.add('visible');
      } else {
        badgeTotal.textContent = '';
        badgeTotal.classList.remove('visible');
      }
    }
  }

  function handleApplyFilter(type) {
    const filter = this;
    const otherTags = [...this.parent.filterItems.values()].filter(({ value }) => value !== filter.value);

    switch (type) {
      case chooseType.BUTTON_CHOOSE_ALL:
        filter.isSelected = false;
      case chooseType.BUTTON_CHOOSE:
        otherTags.forEach((tag) => (tag.isSelected = true));
        break;

      case chooseType.BUTTON_CLEAR_ALL:
        filter.isSelected = true;
        break;
    }

    updateGroups();
  }

  function handleClearAll() {
    updateGroups();
  }

  function handleChooseAllFor(group) {
    const groupId = group.filterOptionId;
    const tags = group.children.map(({ value }) => value).filter(Boolean);
    const firstTagElement = group.children[0];

    const globals = window.BoostPFS?.Globals;

    return () => {
      if (!globals) return;

      const type = defineChooseTypeBy(groupId);
      const mustClear = type === chooseType.BUTTON_CLEAR_ALL;
      const params = mustClear ? [firstTagElement.value] : tags;

      globals.queryParams[groupId] = params;
      firstTagElement.onApplyFilter && firstTagElement.onApplyFilter(type);

      // smartMart:added experiment: send set/clear all tag group as Amplitude event
      document.dispatchEvent(new CustomEvent('filter:tree', {detail: {
          type: type,
          params: params,
        } 
      }));
    };
  }

  function addChooseButtonTo(_group, groupId) {
    const _groupId = groupId || _group.filterOptionId;
    const group = getGroup(_groupId) || _group;
    const list = group[keys.ITEMS_CONTAINER]?.get(0);

    if (!list) return;

    const chooseAllButton = list?.querySelector(`.${keys.BUTTON_SELECTOR}`);
    const tags = [...group.filterItems.values()];
    const hasDisabled = tags.filter(({ docCount }) => !docCount).length > 0;
    const buttonText = getChooseTextBy(group);

    if (chooseAllButton) {
      const span = chooseAllButton.querySelector(`.${keys.BUTTON_TEXT_SELECTOR}`);

      if (hasDisabled) chooseAllButton.parentNode.classList.add('disabled');

      span.textContent = buttonText;
      return;
    }

    const li = document.createElement('li');
    const button = document.createElement('button');
    const span = document.createElement('span');

    span.classList.add(keys.BUTTON_TEXT_SELECTOR);
    span.textContent = buttonText;

    button.classList.add('boost-pfs-filter-button');
    button.addEventListener('click', handleChooseAllFor(group));
    button.appendChild(span);

    li.classList.add('boost-pfs-filter-option-item', 'boost-pfs-filter-option-label', keys.BUTTON_SELECTOR);
    if (hasDisabled) li.classList.add('disabled');
    li.appendChild(button);

    list.prepend(li);
  }

  function getChooseTextBy(group) {
    const type = defineChooseTypeBy(group.filterOptionId);

    return state.data.button[keys[type]].replace(keys.BUTTON_GROUP, group.label);
  }

  function defineChooseTypeBy(groupId) {
    const filterItems = getFilters(groupId);
    const selectedTagsCount = filterItems.filter(({ isSelected }) => Boolean(isSelected)).length;

    if (selectedTagsCount === 0) return chooseType.BUTTON_CHOOSE;
    if (selectedTagsCount < filterItems.length) return chooseType.BUTTON_CHOOSE_ALL;
    return chooseType.BUTTON_CLEAR_ALL;
  }

  function getClearAll() {
    if (!window.boostPFS) return null;

    const trees = window.boostPFS.filter.filterTrees;
    const clearAll = !trees.length ? null : trees[0].children.filter(({ clearAllButton }) => Boolean(clearAllButton)).pop().clearAllButton;

    return clearAll;
  }

  function getFilters(groupId) {
    if (!window.boostPFS) return [];

    const trees = window.boostPFS.filter.filterTrees;
    const filterItems = !trees.length ? [] : [...trees[0].filterOptions.get(groupId).filterItems.values()];

    return filterItems;
  }

  function getGroup(groupId) {
    if (!window.boostPFS) return {};

    const groups = getGroups();

    return groups.get(groupId);
  }

  function getGroups() {
    if (!window.boostPFS) return new Map();

    const trees = window.boostPFS.filter.filterTrees;
    const groups = !trees.length ? new Map() : trees[0].filterOptions;

    return groups;
  }

  function inject(sourceObject, actionName, callback) {
    const objectId = (() => {
      if (!sourceObject.$element?.length) return null;
      const key = Object.keys(sourceObject.$element[0]).filter((key) => key.startsWith('_lo_node_id_')).join('');
      return sourceObject.$element[0][key];
    })();
    const action = sourceObject[actionName];

    if (!action || state.injected.includes(objectId)) return;

    if (objectId) state.injected.push(objectId);

    sourceObject[actionName] = function (...args) {
      callback.bind(this)(...args);
      action.bind(this)();
    };
  }

  function runForEachGroup(callback) {
    if (!callback || !window.boostPFS) return;

    const result = [];
    const trees = window.boostPFS.filter.filterTrees;
    const groups = !trees.length ? [] : trees[0].filterOptions;

    groups.forEach((props) => {
      result.push(callback(props));
    });

    return result;
  }

  async function getBoost() {
    const start = Date.now();
    const delay = 3000;

    const tick = (resolve) => () => {
      const current = Date.now();
      const boost = window.boostPFS;
      const boostConfig = window.boostPFSConfig;
      const hasBoost = boost && boostConfig;

      if (hasBoost || current - start > delay) {
        window.boostPFS = boost;
        window.boostPFSConfig = boostConfig;
        state.boostPFSConfig = boostConfig;

        if (!boost.filter?.filterTrees?.length) return;

        state.collectionId = boost.filter.filterTrees[0].collectionId;
        resolve();

        return;
      }

      window.requestAnimationFrame(tick(resolve));
    };

    await new Promise((resolve) => window.requestAnimationFrame(tick(resolve)));
  }

  function getData() {
    const node = document.querySelector('#pnk-data');

    if (!node) return;

    state.data = JSON.parse(node.textContent) || {};
  }

  // ------------------------------------------------------------------------------ //

  async function getFilteredProducts({ filters = [], limit = 24, page = 1, relation = relationType.DEFAULT }) {
    const url = getApiUrlWithFilters({ filters, limit, page });

    const actions = {
      [relationType.OR]: async () => {
        const { products, totalCount } = await fetchProducts(url);
        const pages = Math.floor(totalCount / limit) + 1;

        if (pages === 1) return products;

        for (let page = 2; page < pages + 1; page++) {
          url.searchParams.set('page', page);

          const batch = await fetchProducts(url);

          products.push(...batch.products);
        }

        return products;
      },
      [relationType.DEFAULT]: async () => {
        filters.forEach(({ id, values }) => {
          if (!values.length) return;

          values.forEach((value) => {
            url.searchParams.append(id, value);
          });
        });

        if (!url.search.length) return [];

        const { products } = await fetchProducts(url);

        return products;
      },
    };

    const products = await actions[relation]();

    return uniqProducts(products);
  }

  function getApiUrlWithFilters({ filters = [], limit = 24, page = 1 }) {
    const config = window.boostPFSConfig;
    const collectionId = state.collectionId;

    if (!config) {
      console.error('Error! Can\'t find boost app config.');
      return null;
    }

    const url = new URL(config.api.filterUrl || '');
    const params = getQueryParams({ config, collectionId, limit, page });

    Object.entries(params).forEach(setParamTo(url));

    filters.forEach(({ id, values }) => {
      if (!values.length) return;

      values.forEach((value) => {
        url.searchParams.append(id, value);
      });
    });

    return url;
  }

  function uniqProducts(products) {
    const flat = products.reduce((acc, group) => {
      const isGroup = Array.isArray(group);

      return [...acc, ...(isGroup ? group : [group])];
    }, []);

    return flat.reduce((acc, product) => {
      const hasProduct = Boolean(acc.filter(({ id }) => id === product.id).length);

      return hasProduct ? acc : [...acc, product];
    }, []);
  }

  async function fetchProducts(url) {
    return await fetch(url.toString())
      .then(pumpData)
      .then(({ data, url }) => {
        const result = `${data.replace(/'/g, '&#39;')}`.split('BoostPFSFilterCallback(').splice(-1).join('');
        const json = JSON.parse(result.substring(0, result.length - 2)) || {};
        const { products = [], total_product = 0 } = json;

        return { products, totalCount: total_product, url };
      });
  }

  async function pumpData(response) {
    const data = [];
    const bytes = [];
    const { body, url, ok } = response;
    const reader = body.getReader();
    const decoder = new TextDecoder();

    const result = { url, ok };

    const pump = ({ done, value: chunk }) => {
      if (done) {

        return {
          ...result,
          data: data.join(''),
        };
      }

      data.push(decoder.decode(chunk));
      bytes.push(chunk.length);

      return reader.read().then(pump);
    };

    return reader.read().then(pump);
  }

  function setParamTo(url) {
    if (!url?.searchParams) return () => {};
    return ([k, v]) => url.searchParams.set(k, v);
  }

  function getQueryParams({ config, collectionId, limit, page }) {
    return {
      t: Date.now(),
      _: 'pf',
      shop: config.shop.domain,
      page,
      limit,
      sort: 'manual',
      display: 'grid',
      collection_scope: collectionId,
      tag: '',
      product_available: false,
      variant_available: false,
      zero_options: true,
      build_filter_tree: false,
      check_cache: true,
      locale: config.general.current_locale,
      callback: 'BoostPFSFilterCallback',
      event_type: 'filter',
    };
  }
}();
